import { html, LitElement, TemplateResult, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import style from './BubbleCluster.scss?inline';

/**
 * Componente wrapper de los elementos bubble
 */
@customElement('app-bubble-cluster')
export class BubbleClusterComponent extends LitElement {
    @property({ type: Number }) k_length = 0;

    static styles = [unsafeCSS(style)];

    protected render(): TemplateResult {
        return html`
            <div class="bubble-cluster">
                ${this.k_length > 1
                ? html`<span class="count">${this.k_length}</span>`
                : null
            }
            </div>
        `;
    }
}